/** Side of a destination chip in the palette and under the finger: the 44pt button hit target. */
export const PRIMARY_NAVIGATION_DESTINATION_CHIP_SIZE = 44;

/**
 * Side of a chip drawn in the strip editor (`size-8`). The iOS icon row is only 48pt tall and the
 * scene's fade overlaps the strip's top 9pt, so a full-size chip would lose its top edge under it.
 * Its 44pt touch target stays the same.
 */
export const PRIMARY_NAVIGATION_STRIP_EDITOR_CHIP_SIZE = 32;

/** Ghost scale that matches a strip editor chip, for picking one up and landing one. */
export const PRIMARY_NAVIGATION_STRIP_EDITOR_CHIP_SCALE =
  PRIMARY_NAVIGATION_STRIP_EDITOR_CHIP_SIZE / PRIMARY_NAVIGATION_DESTINATION_CHIP_SIZE;

/**
 * Hold before a drag starts wherever the dragged tile shares a vertically scrolling page (the
 * Settings palette, the inline preview strip), so a quick swipe still scrolls.
 */
export const PRIMARY_NAVIGATION_CUSTOMIZATION_LONG_PRESS_MS = 220;
